export class DockPanelContractError extends TypeError {
  constructor(message, code = "INVALID_DOCK_PANEL") {
    super(message);
    this.name = "DockPanelContractError";
    this.code = code;
  }
}


export class DockPanelRegistryError extends Error {
  constructor(message, code = "DOCK_PANEL_REGISTRY_ERROR") {
    super(message);
    this.name = "DockPanelRegistryError";
    this.code = code;
  }
}


export class DockLayoutContractError extends TypeError {
  constructor(message, code = "INVALID_DOCK_LAYOUT") {
    super(message);
    this.name = "DockLayoutContractError";
    this.code = code;
  }
}


export class DockingRuntimeError extends Error {
  constructor(message, code = "DOCKING_RUNTIME_ERROR") {
    super(message);
    this.name = "DockingRuntimeError";
    this.code = code;
  }
}
